// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"95a0a924","977":"bc671a4b"}[chunkId] + ".chunk.js";
};